import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Reveal } from '../components/Reveal';
import { Showcase } from '../components/Showcase';
import { ProjectCategory, projectFilters, projects } from '../data/site';

const Projects: React.FC = () => {
  const location = useLocation();
  const [filter, setFilter] = useState<'all' | ProjectCategory>('all');

  const list = useMemo(
    () => (filter === 'all' ? projects : projects.filter((p) => p.category === filter)),
    [filter]
  );

  useEffect(() => {
    const id = location.hash.replace('#', '');
    if (!id) return;
    setFilter('all');
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => window.clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <header className="page-intro">
        <div className="wrap">
          <p className="eyebrow">İşler</p>
          <h1>Mustafa Gürses projeleri</h1>
          <p>
            Mustafa Gürses’in yazılım işleri: web ürünleri canlı sitede; mobil uygulamalar Play Store
            ve App Store’da.
          </p>
        </div>
      </header>

      <div className="wrap">
        <div className="filters">
          {projectFilters.map((f) => (
            <button
              key={f.id}
              type="button"
              className={`filter-btn ${filter === f.id ? 'is-on' : ''}`}
              onClick={() => setFilter(f.id)}
            >
              {f.label}
            </button>
          ))}
        </div>

        {list.map((project, i) => (
          <Reveal key={project.id}>
            <div id={project.id} style={{ scrollMarginTop: 96 }}>
              <Showcase project={project} flip={i % 2 === 1} />
            </div>
          </Reveal>
        ))}
      </div>

      <section className="cta-band">
        <div className="wrap">
          <h2>Bir sonraki ürün.</h2>
          <p>Kapsamı konuşalım.</p>
          <Link to="/contact" className="btn btn-fill">
            Yaz
          </Link>
        </div>
      </section>
    </>
  );
};

export default Projects;
